var map = {
	"./Hyphen.png": 26538,
	"./Hyu.png": 22581,
	"./Lifespan.png": 60466,
	"./Renee.png": 66065,
	"./Snitch.png": 99832,
	"./Swiss Beauty.png": 71213,
	"./WeRize.png": 81951,
	"./adidas.png": 55303,
	"./amazon.png": 56769,
	"./beato.png": 57385,
	"./bella-vita.png": 53934,
	"./boat.png": 10781,
	"./boldcare.png": 81674,
	"./bombay-shaving-company.png": 13087,
	"./booking-com.png": 55252,
	"./cadbury.png": 94798,
	"./clove-oral-care.png": 46163,
	"./croma.png": 87756,
	"./dot-and-key.png": 95730,
	"./fab-india.png": 75494,
	"./firstcry.png": 54741,
	"./fitspire.png": 60892,
	"./flipkart.png": 56949,
	"./forest-essentials-india.png": 4012,
	"./foxtale.png": 24242,
	"./giva.png": 92333,
	"./go-noise.png": 64289,
	"./kama.png": 71623,
	"./koparo-clean.png": 12641,
	"./libas.png": 60049,
	"./mamaearth.png": 82867,
	"./mcaffeine.png": 77982,
	"./medibuddy.png": 57191,
	"./minimalist.png": 94339,
	"./muscleblaze.png": 17185,
	"./neeman.png": 9207,
	"./nykaa.png": 92965,
	"./plum-goodness.png": 69634,
	"./puer.png": 55799,
	"./puma.png": 42941,
	"./shopsy.png": 42501,
	"./shyaway.png": 98893,
	"./smytten.png": 62059,
	"./sova-health.png": 74271,
	"./ssbeauty.png": 87247,
	"./the-derma-co.png": 91574,
	"./the-man-company.png": 53677,
	"./times-prime.png": 28872,
	"./truemeds.png": 37281,
	"./weryze.png": 35328,
	"./world-of-asaya.png": 81361,
	"./wow.png": 49871,
	"./xyxx-crew.png": 92313,
	"./zandu-care.png": 40958
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42850;